/**
 * Display round name from code
 */
export const displayRound = (value) => {
  const rounds = {
    't': 'Training',
    'q': 'Quali',
    'trial': 'Trial',
    'r1': 'Round 1',
    'r2': 'Round 2',
    'r3': 'Round 3',
    'r4': 'Round 4'
  }
  return rounds[value] || '-'
}

/**
 * Display value or dash if empty
 */
export const displayValue = (value) => {
  return value || '-'
}

/**
 * Display float value with 1 decimal or dash if empty
 */
export const displayFloatValue = (value) => {
  return value ? value.toFixed(1) : '-'
}

/**
 * Shorten name (Lastname, Firstname -> Lastname, F)
 */
export const shorten = (value) => {
  if (!value) return value
  const name = value.split(', ')
  if (name.length < 2) return value
  return `${name[0]}, ${name[1].charAt(0)}`
}

/**
 * Calculate age from date of birth
 */
export const formatAge = (dateString) => {
  if (!dateString) return 'n/a'
  
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  
  return age
}

/**
 * Calculate total distance points including wind and gate compensation
 */
export const totalDistancePoints = (current) => {
  if (!current) return '-'
  
  const points = current.length?.points || 0
  if (!points) return '-'
  
  const windCompensation = current.wind?.compensation || 0
  const gatecomp = current.gatecomp || 0
  
  return (points + windCompensation + gatecomp).toFixed(1)
}

/**
 * Format gate compensation with + sign for positive values
 */
export const gateCompensation = (value) => {
  if (!value) return '0'
  if (value > 0) return `+${value}`
  return value.toString()
}

/**
 * Get wind compensation formatted
 */
export const windCompensation = (current) => {
  if (!current) return '-'
  
  const length = current.length?.length || 0
  if (!length) return '-'
  
  const compensation = current.wind?.compensation
  if (compensation) {
    return compensation <= 0 ? compensation : `+${compensation}`
  }
  return '-'
}

/**
 * Get wind speed
 */
export const windSpeed = (current) => {
  if (!current) return '-'
  
  const length = current.length?.length
  if (!length) return '-'
  
  return current.wind?.wind || '-'
}

/**
 * Get final rank with special status handling
 */
export const finalRank = (row) => {
  if (row.dns) return 'DNS'
  if (row.nps) return 'NPS'
  if (row.dq) return 'DSQ'
  return row.final_rank
}

/**
 * Format image path
 */
export const displayImage = (image) => {
  return image || '/images/default-jumper.png'
}
